import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { MultiLangStrDto } from 'src/app/models/multi-lang-str-dto';

@Component({
  selector: 'app-unauthorized-dialog',
  templateUrl: './unauthorized-dialog.component.html',
  styleUrls: ['./unauthorized-dialog.component.scss']
})
export class UnauthorizedDialogComponent {
  @Input() unauthorizedLicenses: Array<{ license: string; expedition: string; }> = [];
  @Input() isOpen: boolean = false;
  @Input() currentLanguage!: string;
  @Output() onClose = new EventEmitter<void>();

  handleClose(): void {
    this.onClose.emit();
  }
}